// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_s5Z","cls2":"VideoPlayerMainContent-cls2_AOm VideoPlayerMainContent-cls1_s5Z"};